import "./App.css";
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import loadable from '@loadable/component'
import Category from "./components/Industries/Category/Category";
const Subscribe = loadable(() => import('./components/Subscribe/Subscribe'));
const Success = loadable(() => import('./components/Success/Success'));
const Success2 = loadable(() => import('./components/Success/Success2'));
const Styling = loadable(() => import("./StylingComponent"));
const Navbar = loadable(() => import("./components/Navbar/Navbar"));
const Footer = loadable(() => import("./components/Footer/Footer.jsx"));
const HomePage = loadable(() => import("./components/HomePage/HomePage"));
const StrategyConsultancy = loadable(() => import("./components/StrategyConsultancy/StrategyConsultancy"));
const IntractiveBluePrint = loadable(() => import("./components/IntractiveBluePrint/IntractiveBluePrint"));
const WebDesignDevelopment = loadable(() => import("./components/IntractiveBluePrint/WebDesignDevelopment.jsx"));
const EcommerceWebsite = loadable(() => import("./components/IntractiveBluePrint/EcommerceWebsite.jsx"));
const StaticWebsite = loadable(() => import("./components/IntractiveBluePrint/StaticWebsite.jsx"));
const DynamicWebsite = loadable(() => import("./components/IntractiveBluePrint/DynamicWebsite.jsx"));
const FitnessIndustries = loadable(() => import("./components/IntractiveBluePrint/FitnessIndustries.jsx"));

const CorporateStrategy = loadable(() => import("./components/CorporateStrategy/CorporateStrategy"));
const BrandPositioning = loadable(() => import("./components/BrandPositioning/BrandPositioning"));
const AboutCorporality = loadable(() => import("./components/AboutCorporality/AboutCorporality"));
const PartnershipProgrammes = loadable(() => import("./components/PartnershipProgrammes/PartnershipProgrammes"));
const SustainableGrowth = loadable(() => import("./components/SustainableGrowth/SustainableGrowth"));
const Blogs = loadable(() => import("./components/Blogs/Blogs"));
const BusinessDevlopment = loadable(() => import("./components/BusinessDevelopment/CxoStrategy"));
const BusinessProcessAutomation = loadable(() => import("./components/BusinessDevelopment/BusinessProcessAutomation"));
const CxoStrategy = loadable(() => import("./components/CxoStrategy/CxoStrategy"));
const StrategyAndConsulting = loadable(() => import("./components/StrategyAndConsulting/StrategyAndConsulting"));
const InclusionAndDiversity = loadable(() => import("./components/InclusionAndDiversity/InclusionAndDiversity"));
const WorkWithClient = loadable(() => import("./components/WorkWithClient/WorkWithClient"));
const GoToMarketing = loadable(() => import("./components/GoToMarketing/GoToMarketing"));
const Contact = loadable(() => import("./components/Contact/Contact"));
const DigitalMediaMarketing = loadable(() => import("./components/DigitalMediaMarketing/DigitalMediaMarketing"));
const Clients = loadable(() => import("./components/CauseStudies/Clients"));
const CorporalityBooksList = loadable(() => import("./components/CorporalityBooks/CorporalityBooksList"));  
const JourneyOfPerseverance = loadable(() => import("./components/CorporalityBooks/JourneyOfPerseverance"));
const ResearchPapers = loadable(() => import("./components/ResearchPapers/ResearchPapers"));
const WhyCorporalityEffect = loadable(() => import("./components/WhyCorporalityEffect/WhyCorporalityEffect"));
const WhatIsCorporalityEffect = loadable(() => import("./components/WhatIsCorporalityEffect/WhatIsCorporalityEffect"));
const CulturallyConditioned = loadable(() => import("./components/CulturallyConditioned/CulturallyConditioned"));
const InboundShifting = loadable(() => import("./components/InboundShifting/InboundShifting"));
const Careers = loadable(() => import("./components/Careers/Careers"));
const TermsConditions = loadable(() => import("./components/TermsConditions/TermsConditions"));
const PrivacyPolicy = loadable(() => import("./components/PrivacyPolicy/PrivacyPolicy"));
const AccountBasedMarketing = loadable(() => import("./components/AccountBasedMarketing/AccountBasedMarketing"));
const OutsourcedCMO = loadable(() => import("./components/OutsourcedCMO/OutsourcedCMO"));
const MarketingModelApproch = loadable(() => import("./components/MarketingModelApproch/MarketingModelApproch"));
const Blogs2 = loadable(() => import("./components/Blogs/Blogs2"));
const OurTeam = loadable(() => import("./components/OurTeam/OurTeam"));
const ServiceInsights = loadable(() => import("./components/ServiceInsights/ServiceInsights"));
const Single = loadable(() => import("./components/Blog/Single"));
const SingleArticle = loadable(() => import("./components/Articles/SingleArticle"));
const Articles = loadable(() => import("./components/Articles/Articles"));
const CooInsights = loadable(() => import("./components/Insights/CooInsights"));
const CmoInsights = loadable(() => import("./components/Insights/CmoInsights"));
const CeoInsights = loadable(() => import("./components/Insights/CeoInsights"));
const CxoInsights = loadable(() => import("./components/Insights/CxoInsights"));
const CorporalityStrikers = loadable(() => import("./components/CorporalityStrikers/CorporalityStrikers"));
const PageNotFound = loadable(() => import("./components/PageNotFound/PageNotFound"));
const Sitemap = loadable(() => import("./components/Sitemap/Sitemap"));
const CSuitSingle = loadable(() => import("./components/Insights/CSuitSingle/CSuitSingle"));
const Search = loadable(() => import("./components/Search/Search"));
const MedTech = loadable(() => import("./components/Industries/MedTech"));
const Finance = loadable(() => import("./components/Industries/Finance"));
const Agricultureebook = loadable(() => import("./components/Industries/Agriculture-ebook"));
const Geospatial = loadable(() => import("./components/Industries/Geospatial"));
const Biotech = loadable(() => import("./components/Industries/Biotech"));
const Nanotech = loadable(() => import("./components/Industries/Nanotech"));
const AgeCareAndRetirement = loadable(() => import("./components/Industries/AgeCareAndRetirement"));
const Allied = loadable(() => import("./components/Industries/Allied"));
const IndustrialEquipment = loadable(() => import("./components/Industries/IndustrialEquipment"));
const Metal = loadable(() => import("./components/Industries/Metal"));
const Construction = loadable(() => import("./components/Industries/Construction"));
const Manufacturing = loadable(() => import("./components/Industries/Manufacturing"));
const InformationTechnology = loadable(() => import("./components/Industries/InformationTechnology"));
const HighTech = loadable(() => import("./components/Industries/HighTech"));
const Agriculture = loadable(() => import("./components/Industries/Agriculture"));
const HealthCare = loadable(() => import("./components/Industries/HealthCare"));
const UtilitiesAndEnergy = loadable(() => import("./components/Industries/UtilitiesAndEnergy"));
const IndustrySingle = loadable(() => import("./components/Industries/IndustrySingle/IndustrySingle"));
const IndustryCategory = loadable(() => import("./components/Industries/Category/IndustryCategory"));
const Fintech = loadable(() => import("./components/Industries/Fintech"));
const Insurtech = loadable(() => import("./components/Industries/Insurtech"));
const Edutech = loadable(() => import("./components/Industries/Edutech"));
const SingleClient = loadable(() => import("./components/CauseStudies/SingleClient"));
const CruiseAndTourism = loadable(() => import("./components/Industries/CruiseAndTourism"));
const Pricing = loadable(() => import("./components/Pricing/Pricing"));
const CSuitCategory = loadable(() => import("./components/Insights/Category/CSuitCategory"));
const Biotechebook = loadable(() => import("./components/Industries/Biotech-ebook"));
const AgeCareAndRetirementebook = loadable(() => import("./components/Industries/AgeCareAndRetirement-ebook"));
const Metalebook = loadable(() => import("./components/Industries/Metal-ebook"));
const Fintechebook = loadable(() => import("./components/Industries/Fintech-ebook"));
const Geospatialebook = loadable(() => import("./components/Industries/Geospatial-ebook"));
const Medtechebook = loadable(() => import("./components/Industries/Medtech-ebook"));
const Informationtechnologyebook = loadable(() => import("./components/Industries/Informationtechnology-ebook"));
const Manufacturingebook = loadable(() => import("./components/Industries/Manufacturing-ebook"));
const Nanotechebook = loadable(() => import("./components/Industries/Nanotech-ebook"));
const UtilitiesAndEnergyebook = loadable(() => import("./components/Industries/UtilitiesAndEnergy-ebook"));
const IndustrialEquipmentebook = loadable(() => import("./components/Industries/IndustrialEquipment-ebook"));
const Alliedebook = loadable(() => import("./components/Industries/Allied-ebook"));
const Constructionebook = loadable(() => import("./components/Industries/Construction-ebook"));
const CruiseAndTourismebook = loadable(() => import("./components/Industries/CruiseAndTourism-ebook"));
const Insurtechebook = loadable(() => import("./components/Industries/Insurtech-ebook"));
const Edutechebook = loadable(() => import("./components/Industries/Edutech-ebook"));
const Hightechebook = loadable(() => import("./components/Industries/Hightech-ebook"));
const UpcomingEvent = loadable(() => import('./components/Navbar/UpcomingEvent/UpcomingEvent'));
const FaqBDM = loadable(() => import("./components/BusinessDevelopment/Faqs"));
//const IndustriesCategories = loadable(() => import('./components/Industries/Category/Category'));

function App() {
  return (
    <>
      <Styling />
      <UpcomingEvent/>
      <BrowserRouter>
        <Navbar />

        <Routes>

          <Route path="/about-corporality" element={<AboutCorporality />} />

          <Route path="/brand-positioning" element={<BrandPositioning />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/corporate-strategy" element={<CorporateStrategy />} />

          <Route path="/digital-media-marketing" element={<DigitalMediaMarketing />} />

          <Route path="/goto-market-strategy" element={<GoToMarketing />} />

          <Route path="/business-development" element={<BusinessDevlopment />} />

          <Route path="/business-process-automation" element={<BusinessProcessAutomation />} />
		  
		      <Route path="/cxo-strategy" element={<CxoStrategy />} />

          <Route path="/inclusion-and-diversity" element={<InclusionAndDiversity />} />

          <Route path="/interactive-blueprint" element={<IntractiveBluePrint />} />

          <Route path="/website-design-and-development" element={<WebDesignDevelopment />} />
          <Route path="/ecommerce-website" element={<EcommerceWebsite />} />
          <Route path="/static-website" element={<StaticWebsite />} />
          <Route path="/dynamic-website" element={<DynamicWebsite />} />

          <Route path="/fitness-industries" element={<FitnessIndustries />} />

          <Route path="/partnership-programmes" element={<PartnershipProgrammes />} />

          <Route path="/strategy-and-consulting" element={<StrategyAndConsulting />} />

          <Route path="/strategic-consultancy" element={<StrategyConsultancy />} />

          <Route path="/sustainable-growth" element={<SustainableGrowth />} />

          <Route path="/work-with-clients" element={<WorkWithClient />} />

          <Route path="/article" element={<Articles />} />

          <Route path="/research-papers" element={<ResearchPapers />} />

          <Route path="/clients" element={<Clients />} />

          <Route path="/corporality-books" element={<CorporalityBooksList />} />
          <Route path="/book/journey-of-perseverance" element={<JourneyOfPerseverance />} />

          <Route path="/why-corporality-effect" element={<WhyCorporalityEffect />} />
          <Route path="/what-is-corporality-effect" element={<WhatIsCorporalityEffect />} />
          <Route path="/corporality-culturally-conditioned" element={<CulturallyConditioned />} />
          <Route path="/corporality-inbound-shiftings" element={<InboundShifting />} />

          <Route path="/careers" element={<Careers />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="/account-based-marketing" element={<AccountBasedMarketing />} />
          <Route path="/outsourced-cmo" element={<OutsourcedCMO />} />
          <Route path="/marketing-model-approch" element={<MarketingModelApproch />} />

          <Route path="/blog" element={<Blogs2 />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/service-insights" element={<ServiceInsights />} />

          <Route path="/coo-insights" element={<CooInsights />} />
          <Route path="/cmo-insights" element={<CmoInsights />} />
          <Route path="/ceo-insights" element={<CeoInsights />} />
          <Route path="/cxo-insights" element={<CxoInsights />} />

          <Route path="/corporality-striker" element={<CorporalityStrikers />} />

          <Route path="/404" element={<PageNotFound />} />

          <Route path="/sitemap" element={<Sitemap />} />

          <Route path="/medtech" element={<MedTech />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/geospatial" element={<Geospatial />} />
          <Route path="/biotech" element={<Biotech />} />
          <Route path="/nanotech" element={<Nanotech />} />
          <Route path="/age-care-and-retirement" element={<AgeCareAndRetirement />} />
          <Route path="/allied" element={<Allied />} />
          <Route path="/industrial-equipment" element={<IndustrialEquipment />} />
          <Route path="/metal" element={<Metal />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/manufacturing" element={<Manufacturing />} />
          <Route path="/information-technology" element={<InformationTechnology />} />
          <Route path="/high-tech" element={<HighTech />} />
          <Route path="/agriculture" element={<Agriculture />} />
          <Route path="/agriculture-ebook" element={<Agricultureebook/>} />
          <Route path="/health-care" element={<HealthCare />} />
          <Route path="/utilities-and-energy" element={<UtilitiesAndEnergy />} />
          <Route path="/fintech" element={<Fintech />} />
          <Route path="/insurtech" element={<Insurtech />} />
          <Route path="/edutech" element={<Edutech />} />
          <Route path="/cruise-and-tourism" element={<CruiseAndTourism />} />

          <Route path="/pricing" element={<Pricing />} />

          <Route path="/:post_slug" exact element={<Single />} />

          <Route path="/category/:category_slug" element={<Blogs />} />

          <Route path="/article/:article_slug" element={<SingleArticle />} />

          <Route path="/client/:client_slug" element={<SingleClient />} />

          <Route path="/csuit/:csuit_slug" element={<CSuitSingle />} />
          <Route path="/csuit/category/:category_slug" element={<CSuitCategory />} />

          <Route path="/search/:search_keyword" element={<Search />} />
          <Route path="/search/" element={<Search />} />

          <Route path="/industry/:industry_slug" element={<IndustrySingle />} />
          <Route path="/industry/category/:category_slug" element={<IndustryCategory />} />

          <Route path="/biotech-ebook" element={<Biotechebook/>} />
          <Route path="/agecareandretirement-ebook" element={<AgeCareAndRetirementebook/>} />
          <Route path="/metal-ebook" element={<Metalebook/>} />
          <Route path="/fintech-ebook" element={<Fintechebook/>} />
          <Route path="/geospatial-ebook" element={<Geospatialebook/>} />
          <Route path="/medtech-ebook" element={<Medtechebook/>} />
          <Route path="/informationtechnology-ebook" element={<Informationtechnologyebook/>} />
          <Route path="/manufacturing-ebook" element={<Manufacturingebook/>} />

          <Route path="/nanotech-ebook" element={<Nanotechebook/>} />
          <Route path="/utilitiesandenergy-ebook" element={<UtilitiesAndEnergyebook/>} />
          <Route path="/industrialequipment-ebook" element={<IndustrialEquipmentebook/>} />
          <Route path="/allied-ebook" element={<Alliedebook/>} />
          <Route path="/construction-ebook" element={<Constructionebook/>} />
          <Route path="/cruiseandtourism-ebook" element={<CruiseAndTourismebook/>} />
          <Route path="/insurtech-ebook" element={<Insurtechebook/>} />
          <Route path="/edutech-ebook" element={<Edutechebook/>} />
          <Route path="/hightech-ebook" element={<Hightechebook/>} />
          <Route path="/faqs/business-development" element={<FaqBDM/>} />

          <Route path="/subscribe" element={<Subscribe/>}/>
          <Route path="/success" element={<Success/>}/>
          <Route path="/sent" element={<Success2/>}/>
          <Route path="/pricing" element={<Pricing/>}/>

          <Route path="/" exact element={<HomePage />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/industries-categories" element={<Category/>}/>
          {/* <Route path="*" component={<PageNotFound/>}/> */}

        </Routes>

        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
